export const PERIOD_NEXT_2_YEARS = 'PERIOD_NEXT_2_YEARS'
export const PERIOD_NEXT_2_YEARS_FROM_NOW = 'PERIOD_NEXT_2_YEARS_FROM_NOW'
export const PERIOD_NEXT_YEAR = 'PERIOD_NEXT_YEAR'
export const PERIOD_NEXT_YEAR_FROM_NOW = 'PERIOD_NEXT_YEAR_FROM_NOW'
export const PERIOD_NEXT_6_MONTH = 'PERIOD_NEXT_6_MONTH'
export const PERIOD_NEXT_6_MONTH_FROM_NOW = 'PERIOD_NEXT_6_MONTH_FROM_NOW'
export const PERIOD_NEXT_3_MONTH = 'PERIOD_NEXT_3_MONTH'
export const PERIOD_NEXT_3_MONTH_FROM_NOW = 'PERIOD_NEXT_3_MONTH_FROM_NOW'
export const PERIOD_NEXT_MONTH = 'PERIOD_NEXT_MONTH'
export const PERIOD_NEXT_MONTH_FROM_NOW = 'PERIOD_NEXT_MONTH_FROM_NOW'
export const PERIOD_NEXT_6_WEEKS = 'PERIOD_NEXT_6_WEEKS'
export const PERIOD_NEXT_6_WEEKS_FROM_NOW = 'PERIOD_NEXT_6_WEEKS_FROM_NOW'
export const PERIOD_NEXT_3_WEEKS = 'PERIOD_NEXT_3_WEEKS'
export const PERIOD_NEXT_3_WEEKS_FROM_NOW = 'PERIOD_NEXT_3_WEEKS_FROM_NOW'
export const PERIOD_NEXT_WEEK = 'PERIOD_NEXT_WEEK'
export const PERIOD_NEXT_WEEK_FROM_NOW = 'PERIOD_NEXT_WEEK_FROM_NOW'
export const PERIOD_NEXT_30_DAYS = 'PERIOD_NEXT_30_DAYS'
export const PERIOD_NEXT_7_DAYS = 'PERIOD_NEXT_7_DAYS'
export const PERIOD_DAY_6_DAYS_LATER = 'PERIOD_DAY_6_DAYS_LATER'
export const PERIOD_DAY_5_DAYS_LATER = 'PERIOD_DAY_5_DAYS_LATER'
export const PERIOD_DAY_4_DAYS_LATER = 'PERIOD_DAY_4_DAYS_LATER'
export const PERIOD_DAY_3_DAYS_LATER = 'PERIOD_DAY_3_DAYS_LATER'
export const PERIOD_DAY_2_DAYS_LATER = 'PERIOD_DAY_2_DAYS_LATER'
export const PERIOD_THIS_YEAR = 'PERIOD_THIS_YEAR'
export const PERIOD_THIS_MONTH = 'PERIOD_THIS_MONTH'
export const PERIOD_THIS_WEEK = 'PERIOD_THIS_WEEK'
export const PERIOD_TOMORROW = 'PERIOD_TOMORROW'
export const PERIOD_TODAY = 'PERIOD_TODAY'
export const PERIOD_YESTERDAY = 'PERIOD_YESTERDAY'
export const PERIOD_DAY_2_DAYS_BEFORE = 'PERIOD_DAY_2_DAYS_BEFORE'
export const PERIOD_DAY_3_DAYS_BEFORE = 'PERIOD_DAY_3_DAYS_BEFORE'
export const PERIOD_DAY_4_DAYS_BEFORE = 'PERIOD_DAY_4_DAYS_BEFORE'
export const PERIOD_DAY_5_DAYS_BEFORE = 'PERIOD_DAY_5_DAYS_BEFORE'
export const PERIOD_DAY_6_DAYS_BEFORE = 'PERIOD_DAY_6_DAYS_BEFORE'
export const PERIOD_LAST_7_DAYS_AND_TOMORROW = 'PERIOD_LAST_7_DAYS_AND_TOMORROW'
export const PERIOD_LAST_7_DAYS = 'PERIOD_LAST_7_DAYS'
export const PERIOD_LAST_30_DAYS = 'PERIOD_LAST_30_DAYS'
export const PERIOD_LAST_WEEK = 'PERIOD_LAST_WEEK'
export const PERIOD_LAST_WEEK_TILL_NOW = 'PERIOD_LAST_WEEK_TILL_NOW'
export const PERIOD_LAST_3_WEEKS = 'PERIOD_LAST_3_WEEKS'
export const PERIOD_LAST_3_WEEKS_TILL_NOW = 'PERIOD_LAST_3_WEEKS_TILL_NOW'
export const PERIOD_LAST_6_WEEKS = 'PERIOD_LAST_6_WEEKS'
export const PERIOD_LAST_6_WEEKS_TILL_NOW = 'PERIOD_LAST_6_WEEKS_TILL_NOW'
export const PERIOD_LAST_MONTH = 'PERIOD_LAST_MONTH'
export const PERIOD_LAST_MONTH_TILL_NOW = 'PERIOD_LAST_MONTH_TILL_NOW'
export const PERIOD_LAST_3_MONTH = 'PERIOD_LAST_3_MONTH'
export const PERIOD_LAST_3_MONTH_TILL_NOW = 'PERIOD_LAST_3_MONTH_TILL_NOW'
export const PERIOD_LAST_6_MONTH = 'PERIOD_LAST_6_MONTH'
export const PERIOD_LAST_6_MONTH_TILL_NOW = 'PERIOD_LAST_6_MONTH_TILL_NOW'
export const PERIOD_LAST_YEAR = 'PERIOD_LAST_YEAR'
export const PERIOD_LAST_YEAR_TILL_NOW = 'PERIOD_LAST_YEAR_TILL_NOW'
export const PERIOD_LAST_2_YEARS = 'PERIOD_LAST_2_YEARS'
export const PERIOD_LAST_2_YEARS_TILL_NOW = 'PERIOD_LAST_2_YEARS_TILL_NOW'

export const PERIOD_DEFAULT = PERIOD_LAST_7_DAYS

export const ALL_PERIODS = [
    PERIOD_NEXT_2_YEARS,
    PERIOD_NEXT_2_YEARS_FROM_NOW,
    PERIOD_NEXT_YEAR,
    PERIOD_NEXT_YEAR_FROM_NOW,
    PERIOD_NEXT_6_MONTH,
    PERIOD_NEXT_6_MONTH_FROM_NOW,
    PERIOD_NEXT_3_MONTH,
    PERIOD_NEXT_3_MONTH_FROM_NOW,
    PERIOD_NEXT_MONTH,
    PERIOD_NEXT_MONTH_FROM_NOW,
    PERIOD_NEXT_6_WEEKS,
    PERIOD_NEXT_6_WEEKS_FROM_NOW,
    PERIOD_NEXT_3_WEEKS,
    PERIOD_NEXT_3_WEEKS_FROM_NOW,
    PERIOD_NEXT_WEEK,
    PERIOD_NEXT_WEEK_FROM_NOW,
    PERIOD_THIS_YEAR,
    PERIOD_THIS_MONTH,
    PERIOD_THIS_WEEK,
    PERIOD_NEXT_30_DAYS,
    PERIOD_NEXT_7_DAYS,
    PERIOD_DAY_6_DAYS_LATER,
    PERIOD_DAY_5_DAYS_LATER,
    PERIOD_DAY_4_DAYS_LATER,
    PERIOD_DAY_3_DAYS_LATER,
    PERIOD_DAY_2_DAYS_LATER,
    PERIOD_TOMORROW,
    PERIOD_TODAY,
    PERIOD_YESTERDAY,
    PERIOD_DAY_2_DAYS_BEFORE,
    PERIOD_DAY_3_DAYS_BEFORE,
    PERIOD_DAY_4_DAYS_BEFORE,
    PERIOD_DAY_5_DAYS_BEFORE,
    PERIOD_DAY_6_DAYS_BEFORE,
    PERIOD_LAST_7_DAYS_AND_TOMORROW,
    PERIOD_LAST_7_DAYS,
    PERIOD_LAST_30_DAYS,
    PERIOD_LAST_WEEK,
    PERIOD_LAST_WEEK_TILL_NOW,
    PERIOD_LAST_3_WEEKS,
    PERIOD_LAST_3_WEEKS_TILL_NOW,
    PERIOD_LAST_6_WEEKS,
    PERIOD_LAST_6_WEEKS_TILL_NOW,
    PERIOD_LAST_MONTH,
    PERIOD_LAST_MONTH_TILL_NOW,
    PERIOD_LAST_3_MONTH,
    PERIOD_LAST_3_MONTH_TILL_NOW,
    PERIOD_LAST_6_MONTH,
    PERIOD_LAST_6_MONTH_TILL_NOW,
    PERIOD_LAST_YEAR,
    PERIOD_LAST_YEAR_TILL_NOW,
    PERIOD_LAST_2_YEARS,
    PERIOD_LAST_2_YEARS_TILL_NOW
]
